import { render, staticRenderFns } from "./SaleStatusBadge.vue?vue&type=template&id=4e3cc0ef"
import script from "./SaleStatusBadge.vue?vue&type=script&lang=js"
export * from "./SaleStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports